(function () {
  'use strict';

  // Theme toggle — light/dark with localStorage persistence.
  // Initial class is set by an inline script in theme.liquid (FOUC-free).
  const THEME_KEY = 'conduit-theme';
  const root = document.documentElement;
  const themeBtn = document.querySelector('[data-theme-toggle]');
  const syncThemeButton = () => {
    if (!themeBtn) return;
    const isLight = root.classList.contains('theme-light');
    themeBtn.setAttribute('aria-pressed', String(isLight));
    themeBtn.setAttribute(
      'aria-label',
      isLight ? 'Switch to dark mode' : 'Switch to light mode'
    );
  };
  syncThemeButton();
  if (themeBtn) {
    themeBtn.addEventListener('click', () => {
      const next = root.classList.toggle('theme-light') ? 'light' : 'dark';
      try { localStorage.setItem(THEME_KEY, next); } catch (e) {}
      syncThemeButton();
    });
  }
  // Follow system preference only if the user hasn't chosen explicitly.
  const sysMql = window.matchMedia('(prefers-color-scheme: light)');
  const onSysChange = (e) => {
    try { if (localStorage.getItem(THEME_KEY)) return; } catch (err) {}
    root.classList.toggle('theme-light', e.matches);
    syncThemeButton();
  };
  (sysMql.addEventListener || sysMql.addListener).call(sysMql, 'change', onSysChange);

  // Header scroll state — threshold 16px matches SiteHeader.tsx
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 16);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobile menu toggle + hamburger-to-X animation
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const closeMenu = () => {
    if (!mobileMenu || !mobileMenu.classList.contains('is-open')) return;
    mobileMenu.classList.remove('is-open');
    menuBtn && menuBtn.classList.remove('is-open');
    menuBtn && menuBtn.setAttribute('aria-expanded', 'false');
    header && header.classList.remove('is-scrolled');
    document.body.style.overflow = '';
  };
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('is-open');
      menuBtn.classList.toggle('is-open', open);
      menuBtn.setAttribute('aria-expanded', String(open));
      header && header.classList.toggle('is-scrolled', open || window.scrollY > 16);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileMenu.addEventListener('click', (e) => {
      if (e.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeMenu();
    });
    // Close when viewport grows past the mobile breakpoint
    const mql = window.matchMedia('(min-width: 768px)');
    (mql.addEventListener || mql.addListener).call(mql, 'change', (e) => {
      if (e.matches) closeMenu();
    });
  }

  // Hero reveal on load
  const hero = document.querySelector('[data-hero]');
  if (hero) {
    requestAnimationFrame(() => {
      setTimeout(() => hero.classList.add('is-revealed'), 100);
    });
  }

  // Fade-in on scroll — matches Reveal.tsx: once, margin "-80px", 0.9s,
  // cubic-bezier(0.2, 0.8, 0.2, 1). Delay is applied per-element via data-delay.
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );
    document.querySelectorAll('.fade-in').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.fade-in').forEach((el) => el.classList.add('is-visible'));
  }

  // Capabilities tab switcher (homepage)
  document.querySelectorAll('[data-caps]').forEach((caps) => {
    const buttons = caps.querySelectorAll('[data-caps-btn]');
    const panes = caps.querySelectorAll('[data-caps-pane]');
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.getAttribute('data-target');
        buttons.forEach((b) => b.setAttribute('aria-selected', b === btn ? 'true' : 'false'));
        panes.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-id') === target));
      });
    });
  });

  // FAQ accordion (homepage)
  document.querySelectorAll('[data-faq]').forEach((faq) => {
    const items = faq.querySelectorAll('[data-faq-item]');
    items.forEach((item) => {
      const btn = item.querySelector('[data-faq-btn]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        items.forEach((i) => {
          i.classList.remove('is-open');
          const ib = i.querySelector('[data-faq-btn]');
          ib && ib.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  // Get-started form — pill groups + optional optimistic success state
  const form = document.querySelector('form.audit-form');
  if (form) {
    form.querySelectorAll('[data-pill-group]').forEach((group) => {
      group.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn) return;
        group.querySelectorAll('button').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        const hidden = group.querySelector('input[type="hidden"]');
        if (hidden) hidden.value = btn.dataset.value || btn.textContent.trim();
      });
    });
  }
})();
